import React, { useEffect, useState } from 'react';
import { START_TIMES, END_TIMES, UNAVAILABLE } from '../../constants';
import { toAmPm } from '../../time';

const generateTimeOptions = (isEndTime = false) => {
    const options = UNAVAILABLE.map(status => (
        <option key={status} value={status}>{status}</option>
    ));

    const range = isEndTime ? END_TIMES : START_TIMES;

    for (let m = range.begin; m <= range.end; m += 30) {
        options.push(
            <option key={m} value={toAmPm(m)}>{toAmPm(m)}</option>
        );
    }

    return options;
};

const TimePicker = ({ day, availability, handleAvailabilityChange }) => {
    const [startTime, setStartTime] = useState(availability[day]?.startTime || '');
    const [endTime, setEndTime] = useState(availability[day]?.endTime || '');

    useEffect(() => {
        setStartTime(availability[day]?.startTime || '');
        setEndTime(availability[day]?.endTime || '');
    }, [availability, day]);

    const handleChange = (field, value) => {
        if (value === 'Not Available' || value === 'Requested Off') {
            setStartTime(value);
            setEndTime(value);
            handleAvailabilityChange(day, 'startTime', value);
            handleAvailabilityChange(day, 'endTime', value);
        } else {
            if (field === 'startTime') {
                setStartTime(value);
                if (['Not Available', 'Requested Off'].includes(endTime)) {
                    setEndTime('');
                    handleAvailabilityChange(day, 'endTime', '');
                }
            } else {
                setEndTime(value);
                if (['Not Available', 'Requested Off'].includes(startTime)) {
                    setStartTime('');
                    handleAvailabilityChange(day, 'startTime', '');
                }
            }
            handleAvailabilityChange(day, field, value);
        }
    };

    return (
        <div>
            <select
                id={`start-time-${day}`}
                value={startTime}
                onChange={(e) => handleChange('startTime', e.target.value)}
            >
                <option value="">Start Time</option>
                {generateTimeOptions(false)}
            </select>

            <select
                id={`end-time-${day}`}
                value={endTime}
                onChange={(e) => handleChange('endTime', e.target.value)}
                disabled={['Not Available', 'Requested Off'].includes(startTime)}
            >
                <option value="">End Time</option>
                {generateTimeOptions(true)}
            </select>
        </div>
    );
};

export default TimePicker;
